$("#preview-close, #preview-overlay").on("click", function (e) {
  if (
    window.innerWidth < 992 &&
    $(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter").children(".canvas-wrapper").length <= 0 &&
    $(".product_name_title").text()?.indexOf('Foto') != -1
  ) {
    $(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter").prepend($canvasWrapper);
  }
  e.preventDefault();
  $("#preview-container").toggleClass("hidden");
});

function check_valid() {
  $("form #customily-options .swatch-container").each(function () {
    if ($(this).is(":hidden")) return;
    var $checked = $(this).find('input[type="radio"]:checked');
    if ($checked.length) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });

  $("form #customily-options select").each(function () {
    if ($(this).is(":hidden")) return;
    if ($(this).val()) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });

  $('form #customily-options input[type="text"]').each(function () {
    if ($(this).is(":hidden")) return;
    if ($(this).attr("name")?.includes("Optional")) return;
    if ($(this).attr("name")?.includes("optional")) return;
    if ($(this).val().length) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });

  $("form #customily-options .customily-file-input").each(function () {
    if ($(this).is(":hidden")) return;
    var $checked = $(this).find(".cl_remove-image").is(":visible");
    if ($checked) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });
}
$("#btn-preview, #btn-preview-desktop").on("click", function (e) {
  e.preventDefault();
  check_valid();

  if ($(".customily_option").hasClass("customily-required-error")) {
    // alert(
    //   "Please check your design once again. Some required options have been left empty, unselected, or wrongly filled."
    // );
    $("#preview-container").hide();
    $(".customily-required-error input").first().focus();
    $(".customily-required-error")[0].scrollIntoView({ behavior: "smooth", block: "center" });
    $(".customily-required-error select").first().focus();
    $(".customily-required-error textarea").first().focus();
    return;
  }
  if (window.innerWidth < 992 && $(".product_name_title").text()?.indexOf('Foto') != -1) {
    $canvasWrapper = $(".canvas-wrapper");
    $(".preview-image-wrap").html($canvasWrapper);
  } else {
    const canvas = document.getElementById("preview-canvas");
    const dataURL = canvas.toDataURL();
    $("#preview-img").attr("src", dataURL);
  }

  $("#preview-container").removeClass("hidden");
  $("#preview-container").show();
});
